import React, { useRef } from "react";

import { Button, Table } from "antd";
import { GoPlusCircle } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import { FaPrint } from "react-icons/fa6";
import { CiEdit } from "react-icons/ci";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import numberToWords from "../NumberToWords/NumberToWords";
export default function YukXatiShablon({ data, user }) {
  let navigate = useNavigate();
  let elementRef = useRef();

  let sum = data.products.reduce((cal, curr) => {
    return cal + curr.tonna;
  }, 0);
  console.log(data);
  return (
    <div className="pb-[100px] w-[100%] overflow-auto ">
      <div
        ref={elementRef}
        className="flex flex-col gap-6 min-w-[600px]"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <div class="max-w-[900px] w-[100%] font-sans">
          <h1 className="text-center mt-1" style={{ textAlign: "center" }}>
            "МИНЕРАЛ МАРКЕТ" MЧЖ СТИР: 310859855
          </h1>
          <h2
            className="text-[16px] text-center"
            style={{ textAlign: "center" }}
          >
            ЙУЛ ВАРАКАСИ
          </h2>
          <p
            className="text-[16px] text-center"
            style={{ textAlign: "center" }}
          >
            № {data.nakladnoy_id} сонли
          </p>

          <section class="info">
            <p className="text-[14px] leading-1 mb-[4px]">{data.status}</p>
            <p className="text-[14px] leading-1 mb-[4px]">
              berdi:{" "}
              {typeof data.given_by == "object"
                ? data?.given_by.name
                : data?.given_by}
            </p>
            <p className="text-[14px] leading-1 mb-[4px]">
              Автомобиль: {data.auto_number}
            </p>
            <p className="text-[14px] leading-1 mb-[4px]">PNFL: {data.PNFL}</p>
            <p className="text-[14px] leading-1 mb-[4px]">
              Хайдовчи: {data.driver_name}
            </p>
            <p className="text-[14px] leading-1 mb-[4px]">
              Етказиб берувчи: "МИНЕРАЛ МАРКЕТ" MЧЖ СТИР: 310859855
            </p>
            <p className="text-[14px] leading-1 mb-[4px]">
              олди:{" "}
              <Link
                className="text-[14px] leading-1 mb-[4px]"
                to={"/customer/" + data.customer_id}
              >
                {user.name}
              </Link>
            </p>
            <p className="text-[14px] leading-1 mb-[4px]">
              Manzil: {data.where}
            </p>
            <p className="text-[14px] leading-1 mb-[4px]">
              олди-сотди шартнома № {data.ticket}
            </p>
            <p className="text-[14px] leading-1 mb-[4px]">
              шартнома Санаси: {data.ticket_date}
            </p>
            <p className="text-[14px] leading-1 mb-[4px]">Ишончнома № </p>
          </section>

          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
            }}
            border="1"
            className="text-[14px]"
            cellpadding="10"
          >
            <tr>
              <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2">
                №
              </th>
              <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
                Юк номи
              </th>
              <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
                Ўлчов бирлиги
              </th>
              <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
                Тара
              </th>
              <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
                {" "}
                Умумий огирлик
              </th>
              <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
                Соф огирлик
              </th>
            </tr>
            {data.products.map((el) => {
              return (
                <tr>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"></td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    {el.name}
                  </td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    Tn
                  </td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"></td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"></td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                    {el.tonna}
                  </td>
                </tr>
              );
            })}
          </table>
          <footer>
            <div
              className="flex items-center justify-between w-[100%]"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p className="text-[16px] m-0 p-[3px]">
                Жами миқдори: {numberToWords(sum)} Tonna
              </p>
              <p className="text-[16px] m-0 p-[3px]">
                {(sum * 1000) / 50} дона Qop
              </p>
            </div>
            <div
              className="flex items-center justify-between w-[100%]"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p className="text-[14px] pt-1">Phone: +998 93 894 40 00</p>
              <p className="text-[14px] pt-1 w-[50%]" style={{ width: "50%" }}>
                Махсулотни ишлаб чиқарувчи томонидан махсус қопларда
                қадоқанланган холда, сон ва сифати жиҳатдан бутлиги ва
                тўлиқлигини назоратини қилган тартибда
              </p>
            </div>
            <div
              className="flex items-center justify-between mt-2"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p className="text-[16px] m-0 p-[3px]">
                ______________А.Abduvaliev
              </p>
              <p className="text-[16px] m-0 p-[3px]">
                ______________А.Parpiyev
              </p>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
}
